import { render, staticRenderFns } from "./v-return-selector.vue?vue&type=template&id=15bed1db&scoped=true"
import script from "./v-return-selector.vue?vue&type=script&lang=js"
export * from "./v-return-selector.vue?vue&type=script&lang=js"
import style0 from "../../../css/selector-base.less?vue&type=style&index=0&id=15bed1db&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bed1db",
  null
  
)

export default component.exports